import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AddressUpdateModalUI from './AddressUpdateModalUI.js'

class AddressUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            // form events
            submitted: false,
            // form fields
            address: this.props.account.address || '',
            city: this.props.account.city || '',
            state: this.props.account.state || '',
            postalCode: this.props.account.postalCode || '',
            // form errors
            addressError: null,
            cityError: null,
            stateError: null,
            postalCodeError: null,
            stateList: [],
        }
    }

    render() {
        return (
            <AddressUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}
                // form fields
                address={this.state.address}
                onAddressChange={(event) => { this.setState({ address: event.target.value }) }}
                addressError={this.state.addressError}
                setAddressError={(error) => { this.setState({ addressError: error }) }}
                //
                city={this.state.city}
                onCityChange={(event) => { this.setState({ city: event.target.value }) }}
                cityError={this.state.cityError}
                setCityError={(error) => { this.setState({ cityError: error }) }}
                //
                state={this.state.state}
                onStateChange={(event) => { this.setState({ state: event.target.value }) }}
                stateError={this.state.stateError}
                setStateError={(error) => { this.setState({ stateError: error }) }}
                stateList={this.state.stateList}
                //
                postalCode={this.state.postalCode}
                onPostalCodeChange={(event) => { this.setState({ postalCode: event.target.value }) }}
                postalCodeError={this.state.postalCodeError}
                setPostalCodeError={(error) => { this.setState({ postalCodeError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
        this.getState(context)
    }

    onSubmit = () => {
        if (this.state.submitted) return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/accounts/${this.props.account.accountId}/address`,
            this.onSubmitCallback,
            {
                address: this.state.address,
                city: this.state.city,
                state: this.state.state,
                postalCode: this.state.postalCode
            }
        )
    }

    getState(context) {
        let cacheManager = new CacheManager({
            resource: `/api/pub/indiaStates`,
            cacheKey: CacheKeys.State(),
            callback: this.getStateCallback,
            ttlInSecs: 3600
        })
        cacheManager.getObject2(context)
    }

    getStateCallback = (response) => {
        let stateList = response.indiaStateList.map((state) => {
            return { key: state.code, value: state.name };
        });
        this.setState({ errorList: response.errorList, stateList: stateList })
    }

    onSubmitCallback = (response) => {
        const errorList = response.errorList.map(error => error.message)

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.props.onCancelClick()
                this.props.onRefreshClick('noBusy')
            }, 2000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default AddressUpdateModalSF
